export const MAX_APP_CONTAINER_WIDTH_OLD = '1456px';
export const MAX_APP_CONTAINER_WIDTH_NEW = '1920px';

export const getMaxAppContainerWidth = (isNewAppWidthEnabled: boolean) =>
    isNewAppWidthEnabled ? MAX_APP_CONTAINER_WIDTH_NEW : MAX_APP_CONTAINER_WIDTH_OLD;
